import { ROUTES } from "../routes/Routes.constants.js";
const getExperimentUrl = (id, isFeatureRollout) => {
  if (isFeatureRollout) {
    return `${ROUTES.feature.location.pathname}/${id}`;
  }
  return `${ROUTES.experiment.location.pathname}/${id}`;
};
export {
  getExperimentUrl
};
//# sourceMappingURL=ExperimentUrlUtils.js.map
